import { NgModule } from '@angular/core';
import { CompareComponent } from './compare.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../app.material.module';
import { FunctieModule } from '../functie/functie.module';
import { OpleidingModule } from '../opleiding/opleiding.module';
import { RouterModule } from '@angular/router';
import { AccordionModule } from '../accordion/accordion.module';
import { CompareDialogComponent } from './dialog/compare-dialog.component';
import { RadarChartModule } from '../radar-chart/radar-chart.module';
import { CompareSegmentComponent } from './segment/compare-segment.component';
import { CompetenceListModule } from '../competence-list/competence-list.module';
import { ContentModule } from '../../services/content/content.module';

@NgModule({
  declarations: [CompareComponent, CompareDialogComponent, CompareSegmentComponent],
  imports: [
    CommonModule,
    MaterialModule,
    RadarChartModule,
    FunctieModule,
    OpleidingModule,
    RouterModule,
    AccordionModule,
    CompetenceListModule,
    ContentModule
  ],
  exports: [CompareComponent, CompareDialogComponent, CompareSegmentComponent]
})
export class CompareModule {}
